// src/components/common/CategoryChip.jsx
// A task category as a tinted chip in the category's own color, with text
// shaded until it meets WCAG AA contrast (see theme/tint.js).
import React from 'react';
import { Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { tintStyles } from '../../theme/tint';

export default function CategoryChip({ name, color, size = 'small', sx, ...props }) {
  const theme = useTheme();
  if (!color) return <Chip label={name} size={size} variant="outlined" sx={sx} {...props} />;
  return (
    <Chip
      label={name}
      title={name} // full name when a narrow column cuts it off
      size={size}
      sx={{ ...tintStyles(theme, color), fontWeight: 600, ...sx }}
      {...props}
    />
  );
}
